import { actions } from "./Reducer";

export const openCreateStudent = () => ({
  type: actions.OPEN_MODEL_1,
});

export const closeCreateStudent = () => ({
  type: actions.CLOSE_MODEL_1,
});

export const openCreateGroup = () => ({
  type: actions.OPEN_MODEL_2,
});

export const closeCreateGroup = () => ({
  type: actions.CLOSE_MODEL_2,
});

export const openCreateLsson = () => ({
  type: actions.OPEN_MODEL_3,
});

export const closeCreateLesson = () => ({
  type: actions.CLOSE_MODEL_3,
});

export const openCreateStreaming = () => ({
  type: actions.OPEN_MODEL_4,
});

export const closeCreateStreaming = () => ({
  type: actions.CLOSE_MODEL_4,
});

export const openCreateVideos = () => ({
  type: actions.OPEN_MODEL_5,
});

export const closeCreateVideos = () => ({
  type: actions.CLOSE_MODEL_5,
});

export const openCreateEvent = () => ({
  type: actions.OPEN_MODEL_6,
});

export const closeCreateEvent = () => ({
  type: actions.CLOSE_MODEL_6,
});
export const openCreateTeacher = () => ({
  type: actions.OPEN_MODEL_7,
});

export const closeCreateTeacher = () => ({
  type: actions.CLOSE_MODEL_7,
});

export const openCreateTeacherAssistant = () => ({
  type: actions.OPEN_MODEL_8,
});

export const closeCreateTeacherAssistant = () => ({
  type: actions.CLOSE_MODEL_8,
});

export const openShowStudentDataModel = () => ({
  type: actions.OPEN_MODEL_9,
});

export const closeShowStudentDataModel = () => ({
  type: actions.CLOSE_MODEL_9,
});

export const openAddVideoFielsModel = () => ({
  type: actions.OPEN_MODEL_10,
});

export const closeAddVideoFielsModel = () => ({
  type: actions.CLOSE_MODEL_10,
});

export const openCreateChapterModel = () => ({
  type: actions.OPEN_MODEL_11,
});

export const closeCreateChapterModel = () => ({
  type: actions.CLOSE_MODEL_11,
});

export const openCreateLectureModel = () => ({
  type: actions.OPEN_MODEL_12,
});

export const closeCreateLectureModel = () => ({
  type: actions.CLOSE_MODEL_12,
});

export const openUserDataModel = () => ({
  type: actions.OPEN_MODEL_13,
});

export const closeUserDataModel = () => ({
  type: actions.CLOSE_MODEL_13,
});

export const openUserQRCodeModel = () => ({
  type: actions.OPEN_MODEL_14,
});

export const closeUserQRCodeModel = () => ({
  type: actions.CLOSE_MODEL_14,
});

export const openCreateExamDataModel = () => ({
  type: actions.OPEN_MODEL_15,
});

export const closeCreateExamDataModel = () => ({
  type: actions.CLOSE_MODEL_15,
});

export const openCreateQuestionModel = () => ({
  type: actions.OPEN_MODEL_16,
});

export const closeCreateQuestionModel = () => ({
  type: actions.CLOSE_MODEL_16,
});

export const openExamAnswersLoading = () => ({
  type: actions.OPEN_MODEL_17,
});

export const closeExamAnswersLoading = () => ({
  type: actions.CLOSE_MODEL_17,
});

export const openStudentReportModel = () => ({
  type: actions.OPEN_MODEL_18,
});

export const closeStudentReportModel = () => ({
  type: actions.CLOSE_MODEL_18,
});

export const openCreatePaymentModel = () => ({
  type: actions.OPEN_MODEL_19,
});

export const closeCreatePaymentModel = () => ({
  type: actions.CLOSE_MODEL_19,
});

export const openVoucherModel = () => ({
  type: actions.OPEN_MODEL_20,
});

export const closeVoucherModel = () => ({
  type: actions.CLOSE_MODEL_20,
});

export const openAddVoucherModel = (id) => ({
  type: actions.OPEN_MODEL_21,
  payload: id,
});

export const closeAddVoucherModel = () => ({
  type: actions.CLOSE_MODEL_21,
});

export const openAddHomeworkModel = () => ({
  type: actions.OPEN_MODEL_22,
});

export const closeAddHomeworkModel = () => ({
  type: actions.CLOSE_MODEL_22,
});

export const openSolveHomeworkModel = () => ({
  type: actions.OPEN_MODEL_23,
});

export const closeSolveHomeworkModel = () => ({
  type: actions.CLOSE_MODEL_23,
});

export const openTagModel = () => ({
  type: actions.OPEN_MODEL_24,
});

export const closeTagModel = () => ({
  type: actions.CLOSE_MODEL_24,
});

export const openPlaylistModel = () => ({
  type: actions.OPEN_MODEL_25,
});

export const closePlaylistModel = () => ({
  type: actions.CLOSE_MODEL_25,
});

export const openQuestionsListModel = () => ({
  type: actions.OPEN_MODEL_26,
});

export const closeQuestionsListModel = () => ({
  type: actions.CLOSE_MODEL_26,
});

export const openAdminHomeworkCommentModel = () => ({
  type: actions.OPEN_MODEL_27,
});

export const closeAdminHomeworkCommentModel = () => ({
  type: actions.CLOSE_MODEL_27,
});

export const openDeleteHomeworkModel = () => ({
  type: actions.OPEN_MODEL_28,
});

export const closeDeleteHomeworkModel = () => ({
  type: actions.CLOSE_MODEL_28,
});
export const openAddSectionkModel = () => ({
  type: actions.OPEN_MODEL_29,
});

export const closeAddSectionkModel = () => ({
  type: actions.CLOSE_MODEL_29,
});
export const openExamHintkModel = () => ({
  type: actions.OPEN_MODEL_30,
});

export const closeExamHintkModel = () => ({
  type: actions.CLOSE_MODEL_30,
});

export const openRefuseHomeworkModel = () => ({
  type: actions.OPEN_MODEL_32,
});

export const closeRefuseHomeworkModel = () => ({
  type: actions.CLOSE_MODEL_32,
});

export const openAddLiveVideo = () => ({
  type: actions.OPEN_MODEL_34,
});

export const closeAddLiveVideo = () => ({
  type: actions.CLOSE_MODEL_34,
});

export const openAddPaymentSubject = () => ({
  type: actions.OPEN_MODEL_35,
});

export const closeAddPaymentSubject = () => ({
  type: actions.CLOSE_MODEL_35,
})

export const openAddSubjectAdmin = () => ({
  type: actions.OPEN_MODEL_36,
});

export const closeAddSubjectAdmin = () => ({
  type: actions.CLOSE_MODEL_36,
});

export const openShowSubjectAdminDataModel = () => ({
  type: actions.OPEN_MODEL_37,
});

export const closeShowSubjectAdminDataModel = () => ({
  type: actions.CLOSE_MODEL_37,
});

export const openEditStudentPaymentModel = () => ({
  type: actions.OPEN_MODEL_38,
});

export const closeEditStudentPaymentModel = () => ({
  type: actions.CLOSE_MODEL_38,
});

export const openSuspendReasonModel = () => ({
  type: actions.OPEN_MODEL_33,
});

export const closeSuspendReasonModel = () => ({
  type: actions.CLOSE_MODEL_33,
});

export const openCreateAnnouncement = () => ({
  type: actions.OPEN_MODEL_39,
});

export const closeCreateAnnouncement = () => ({
  type: actions.CLOSE_MODEL_39,
});

export const openCreateSubjectAssistPhone = () => ({
  type: actions.OPEN_MODEL_40,
});

export const closeCreateSubjectAssistPhone = () => ({
  type: actions.CLOSE_MODEL_40,
});

export const openCreateAssistant = () => ({
  type: actions.OPEN_MODEL_41,
});

export const closeCreateAssistant = () => ({
  type: actions.CLOSE_MODEL_41,
});

export const openShowAssistantDataModel = () => ({
  type: actions.OPEN_MODEL_42,
});

export const closeShowAssistantDataModel = () => ({
  type: actions.CLOSE_MODEL_42,
});

export const openOfficeHourModal = () => ({
  type: actions.OPEN_MODEL_43,
});

export const closeOfficeHourModal = () => ({
  type: actions.CLOSE_MODEL_43,
});

export const openMarkSchemeModel = () => ({
  type: actions.OPEN_MODEL_44,
});

export const closeMarkSchemeModel = () => ({
  type: actions.CLOSE_MODEL_44,
});

export const openBulkImportQuestionsModel = () => ({
  type: actions.OPEN_MODEL_45,
});

export const closeBulkImportQuestionsModel = () => ({
  type: actions.CLOSE_MODEL_45,
});